const _ = require('lodash');

function InspirationService(Restangular, $rootScope, $window) {
    this._api = Restangular.one('inspiration');
    this.$rootScope = $rootScope;
    this.$window = $window;
    this.inspirationCards = {};
}

InspirationService.prototype.getNavigationItems = function () {
    this._leftPaneItems = this._leftPaneItems || this._api.one('navigation').getList();

    return this._leftPaneItems;
};

InspirationService.prototype.findNavigationItemsByName = function (navItems, parentName, childName) {
    let navItem = _.find(navItems, { UrlPart: parentName });

    if (childName !== undefined && navItem && _.some(navItem.Items)) {
        navItem = _.find(navItem.Items, { UrlPart: childName });
    }

    return navItem;
};

InspirationService.prototype.getCardsByPageID = function (pageId) {
    return this._api.one('page', pageId).getList();
};

InspirationService.prototype.getCardsForUrl = function (url) {
    return this._api.one('cards').get({ url }).then((response) => {
      this.inspirationCards = response.Cards;
      return response;
    });
};

InspirationService.prototype.getDiscoverPathForCard = function (cardId) {
    return this._api.one('cards', cardId).one('DiscoverPath').get();
};

InspirationService.prototype.setContentCardId = function (cardId) {
    let stateChangeErrorOff, clickContentCardOff;
    const self = this;
    self._removeDataSessionStorage('dynamicContentCardId');// just in case

    clickContentCardOff = self.$rootScope.$on('$stateChangeSuccess', function () {
        self.ContentCardId = cardId;
        stateChangeErrorOff();
        clickContentCardOff();

        const navigateAwayOff = self.$rootScope.$on('$stateChangeStart', function () {
            self.ContentCardId = null;
            navigateAwayOff();
        });
    });

    stateChangeErrorOff = self.$rootScope.$on('$stateChangeError', function () {
        self.ContentCardId = null;
        stateChangeErrorOff();
        clickContentCardOff();
    });
};

//Attributes that controls the center panel's behavior for SmallFormat when the item has no children items
InspirationService.prototype.setChildlessItem = function (childlessItem) {
    this._isChildLessItem = childlessItem;
};

InspirationService.prototype.isChildlessItem = function () {
    return this._isChildLessItem;
};

InspirationService.prototype.setDynamicContentCardIdSessionStorage = function (cardId) {
    this._setDataSessionStorage('dynamicContentCardId', cardId);
};

InspirationService.prototype._setNavigateAwayOff = function () {
    let navigateAwayOff;
    const self = this;
    navigateAwayOff = self.$rootScope.$on('$stateChangeSuccess', function () {
        self._removeDataSessionStorage('dynamicContentCardId');
        navigateAwayOff();
    });
};

InspirationService.prototype.getContentCardId = function () {
    this._setNavigateAwayOff();
    return this.ContentCardId
        ? this.ContentCardId
        : this._getDataSessionStorage('dynamicContentCardId');
};

//private session storage apis
InspirationService.prototype._setDataSessionStorage = function (name, data) {
    /// <summary>
    /// Create an item in DOM sessionStorage.
    /// </summary>
    this.$window.sessionStorage.setItem(name, data);

    return data;
};

InspirationService.prototype._removeDataSessionStorage = function (name) {
    /// <summary>
    /// Remove an item in DOM sessionStorage.
    /// </summary>
    this.$window.sessionStorage.removeItem(name);

    // allow chaining
    return this;
};

InspirationService.prototype._getDataSessionStorage = function (name) {
    /// <summary>
    /// Gets an item in DOM sessionStorage.
    /// </summary>
    return this.$window.sessionStorage.getItem(name) || null;
};

module.exports = InspirationService;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/inspiration/inspiration-service.js
 **/